import BookingHeader from "./BookingHeader.jsx";
import { connect } from "react-redux";
import { getCurrentProductURI } from "app/pages/FicheProduit/ficheProduitSelector";
import { getFilteredMarketingBanners } from "app/reducers/partnerSelector.js";
import { getQuotationPriceChangeData } from "app/pages/Booking/Quotation/quotationSelectors.js";

const mapStateToProps = state => {
	return {
		ficheProduitUri: getCurrentProductURI(state),
		resolution: state.resolution,
		brand: state.brand.code,
		marketingBanners: getFilteredMarketingBanners(state),
		quotation: state.quotation,
		booking: state.booking,
		priceChangeData: getQuotationPriceChangeData(state),
	};
};

export default connect(mapStateToProps)(BookingHeader);
